"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagerSelectBox = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const select_box_1 = require("../inputs/select-box");
exports.ManagerSelectBox = (0, styled_components_1.default)(select_box_1.SelectBox) `
  vertical-align: top;
`;
//# sourceMappingURL=select-box.js.map